import commonGlobals from "@opendoor/shared-fe/commonGlobals";
import { getRailsEnv } from "@opendoor/shared-fe/railsEnv";
//#region src/helpers/globals.ts
var secrets = commonGlobals[getRailsEnv()];
var GOOGLE_CLIENT_ID = secrets.googleClientID;
var GOOGLE_MAPS_KEY = secrets.googleMaps;
var SUPPORTED_LOCALES = ["en-US", "es"];
/**
* Gets the current environment in a framework-agnostic way.
* Works with Next.js (Cosmos), Remix (Cake), and browser contexts.
*
* Priority order:
* 1. window.ENV?.DEPLOY_ENV (Remix client-side)
* 2. process.env.NEXT_PUBLIC_DEPLOY_ENV (Next.js client & server)
* 3. process.env.DEPLOY_ENV (Remix server-side)
* 4. getRailsEnv() (Fallback to hostname detection)
*/
var getDeployEnv = () => {
	if (typeof window !== "undefined" && window.ENV?.DEPLOY_ENV) return window.ENV.DEPLOY_ENV;
	if (typeof process !== "undefined" && process.env?.NEXT_PUBLIC_DEPLOY_ENV) return process.env.NEXT_PUBLIC_DEPLOY_ENV;
	if (typeof process !== "undefined" && process.env?.DEPLOY_ENV) return process.env.DEPLOY_ENV;
	return getRailsEnv();
};
/**
* Checks if the current deploy environment is production.
*/
var isProductionEnv = () => {
	return getDeployEnv() === "production";
};
/**
* Checks if the current deploy environment is development.
*/
var isDevelopmentEnv = () => {
	return getDeployEnv() === "development";
};
//#endregion
export { GOOGLE_CLIENT_ID, GOOGLE_MAPS_KEY, SUPPORTED_LOCALES, getDeployEnv, isDevelopmentEnv, isProductionEnv };

//# sourceMappingURL=globals.mjs.map